import { render, staticRenderFns } from "./AddIns.vue?vue&type=template&id=1b349541&"
import script from "./AddIns.vue?vue&type=script&lang=js&"
export * from "./AddIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports